import React from 'react';
import Hero from './HeroCarousel/HeroCarousel';
import Features from './Features';
import CTA from './CTA';
import features from '../../data/features';

// Nuevos componentes para el rediseño
const StatsSection = () => (
    <section className="py-20 bg-gradient-to-r from-gray-900 via-blue-900 to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
                {[
                    { number: '100+', label: 'Campañas estratégicas creadas', icon: '🚀' },
                    { number: '88%', label: 'Aumento promedio en leads de nuestros clientes', icon: '⭐' },
                    { number: '24/7', label: 'Monitoreo y acompañamiento digital', icon: '🛠️' },
                    { number: '5+', label: 'Años de Experiencia Profesional', icon: '🏆' }
                ].map((stat, index) => (
                    <div key={index} className="transform hover:scale-105 transition-transform duration-300">
                        <div className="text-5xl mb-2">{stat.icon}</div>
                        <div className="text-4xl font-bold text-white mb-2">{stat.number}</div>
                        <div className="text-gray-300 font-medium">{stat.label}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const ServicesPreview = () => (
    <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                    Nuestros Servicios Principales
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                    Soluciones integrales que transforman tu negocio desde la tecnología hasta la energía
                </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                    {
                        title: 'Tecnología & Redes',
                        description: 'Infraestructura de red, ciberseguridad y soluciones de conectividad empresarial',
                        icon: '🌐',
                        color: 'from-blue-500 to-cyan-500',
                        features: ['Redes empresariales', 'Ciberseguridad', 'Cloud Computing']
                    },
                    {
                        title: 'Soluciones Empresariales',
                        description: 'Estrategias digitales que generan resultados medibles y crecimiento sostenible',
                        icon: '📈',
                        color: 'from-purple-500 to-pink-500',
                        features: ['SEO/SEM', 'Redes Sociales', 'Automatización']
                    }
                ].map((service, index) => (
                    <div key={index} className="group relative">
                        <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden">
                            <div className={`h-2 bg-gradient-to-r ${service.color}`}></div>
                            <div className="p-8">
                                <div className="text-6xl mb-4 text-center">{service.icon}</div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">{service.title}</h3>
                                <p className="text-gray-600 mb-6 text-center leading-relaxed">{service.description}</p>
                                <ul className="space-y-2 mb-6">
                                    {service.features.map((feature, i) => (
                                        <li key={i} className="flex items-center text-gray-700">
                                            <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                                <button className={`w-full py-3 px-6 rounded-lg bg-gradient-to-r ${service.color} text-white font-semibold hover:opacity-90 transition-opacity`}>
                                    Conocer más
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const TestimonialsSection = () => (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">Lo que dicen nuestros clientes</h2>
                <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto"></div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                    {
                        name: 'María González',
                        company: 'Restaurante La Cocina',
                        text: 'Salient transformó completamente nuestro marketing digital. En 3 meses aumentamos nuestras ventas en un 40%.',
                        rating: 5
                    },
                    {
                        name: 'Carlos Mendoza',
                        company: 'Empresa Industrial',
                        text: 'Salient nos ayudó a optimizar procesos con tecnología y estrategia. Resultados tangibles desde el primer mes.',
                        rating: 5
                    },
                    {
                        name: 'Ana Rodríguez',
                        company: 'Oficina Contable',
                        text: 'Su equipo de redes nos dio una solución integral. Ahora tenemos mejor conectividad y seguridad total.',
                        rating: 5
                    }
                ].map((testimonial, index) => (
                    <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
                        <div className="flex mb-4">
                            {[...Array(testimonial.rating)].map((_, i) => (
                                <span key={i} className="text-yellow-400 text-xl">⭐</span>
                            ))}
                        </div>
                        <p className="text-gray-700 mb-6 italic leading-relaxed">"{testimonial.text}"</p>
                        <div className="border-t pt-4">
                            <p className="font-semibold text-gray-900">{testimonial.name}</p>
                            <p className="text-gray-600 text-sm">{testimonial.company}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const ProcessSection = () => (
    <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">Cómo trabajamos contigo</h2>
                <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                    Un proceso simple y transparente desde el primer contacto hasta los resultados
                </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                {[
                    {
                        step: '01',
                        title: 'Consulta Inicial',
                        description: 'Analizamos tus necesidades y objetivos específicos',
                        icon: '💬'
                    },
                    {
                        step: '02',
                        title: 'Propuesta Personalizada',
                        description: 'Diseñamos una solución integral adaptada a tu negocio',
                        icon: '📋'
                    },
                    {
                        step: '03',
                        title: 'Implementación',
                        description: 'Ejecutamos el proyecto con nuestro equipo especializado',
                        icon: '⚙️'
                    },
                    {
                        step: '04',
                        title: 'Seguimiento',
                        description: 'Monitoreamos resultados y brindamos soporte continuo',
                        icon: '📊'
                    }
                ].map((process, index) => (
                    <div key={index} className="text-center group">
                        <div className="relative mb-6">
                            <div className="w-20 h-20 mx-auto bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300">
                                {process.step}
                            </div>
                            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 text-4xl">
                                {process.icon}
                            </div>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">{process.title}</h3>
                        <p className="text-gray-600 leading-relaxed">{process.description}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const Home = () => {
    return (
        <div className="min-h-screen">
            <Hero />
            <StatsSection />
            <ServicesPreview />
            <Features features={features} />
            <ProcessSection />
            <TestimonialsSection />
            <CTA />
        </div>
    );
};

export default Home;